import { UFBNoticeClickEvent, UFBNoticeImpressionEvent } from '@udemy/browse-event-tracking';
import { ClientEvent, Tracker } from '@udemy/event-tracking';
import { SubscriptionPlanProductType } from './graphql/api-platform-graphql';
export class CategoryNavItemSelectEvent extends ClientEvent {
  constructor({
    context
  }) {
    super('CategoryNavItemSelectEvent');
    this.categoryId = void 0;
    this.subcategoryId = void 0;
    this.topicId = void 0;
    this.uiRegion = void 0;
    this.categoryId = context.categoryId;
    this.subcategoryId = context.subcategoryId;
    this.topicId = context.topicId;
    this.uiRegion = context.uiRegion;
  }
}
export let LearningTypeNavItemType = /*#__PURE__*/function (LearningTypeNavItemType) {
  LearningTypeNavItemType["LABS"] = "labs";
  LearningTypeNavItemType["UDEMY_PRO_PATHS"] = "pro_paths";
  return LearningTypeNavItemType;
}({});
export let AIAssistantNavItemType = /*#__PURE__*/function (AIAssistantNavItemType) {
  AIAssistantNavItemType["DISCOVERY"] = "discovery";
  return AIAssistantNavItemType;
}({});
export let AIElevateNavItemType = /*#__PURE__*/function (AIElevateNavItemType) {
  AIElevateNavItemType["AI_COURSES"] = "ai_courses";
  return AIElevateNavItemType;
}({});
export let SearchBarMXEnum = /*#__PURE__*/function (SearchBarMXEnum) {
  SearchBarMXEnum["NotLoaded"] = "NOT_LOADED";
  SearchBarMXEnum["NewBar"] = "NEW_BAR";
  SearchBarMXEnum["OldBar"] = "OLD_BAR";
  return SearchBarMXEnum;
}({});
export let RolePlayNavItemType = /*#__PURE__*/function (RolePlayNavItemType) {
  RolePlayNavItemType["ROLE_PLAY"] = "role_play";
  return RolePlayNavItemType;
}({});
export class LearningTypeNavItemSelectEvent extends ClientEvent {
  constructor(itemType) {
    super('LearningTypeNavItemSelectEvent');
    this.itemType = void 0;
    this.itemType = itemType;
  }
}
export let AggregatorNavItemType = /*#__PURE__*/function (AggregatorNavItemType) {
  AggregatorNavItemType["CERTIFICATION_PREPARATION"] = "certification_preparation";
  AggregatorNavItemType["CERTIFICATION_SUBJECT_AGGREGATOR"] = "certification_subject_aggregator";
  AggregatorNavItemType["CERTIFICATION_ISSUER_AGGREGATOR"] = "certification_issuer_aggregator";
  AggregatorNavItemType["TOPIC"] = "topic";
  return AggregatorNavItemType;
}({});
export let AcademiesNavItemType = /*#__PURE__*/function (AcademiesNavItemType) {
  AcademiesNavItemType["CAREER_ACADEMY"] = "career_academy";
  AcademiesNavItemType["ALL_ACADEMIES"] = "all_careers_page";
  return AcademiesNavItemType;
}({});
export let AILearningNavItemType = /*#__PURE__*/function (AILearningNavItemType) {
  AILearningNavItemType["LEARN_AI"] = "learn_ai";
  return AILearningNavItemType;
}({});
export let GoogleCertificateNavItemType = /*#__PURE__*/function (GoogleCertificateNavItemType) {
  GoogleCertificateNavItemType["GOOGLE_CERTIFICATES"] = "google_certificates";
  GoogleCertificateNavItemType["GOOGLE_CERTIFICATE_PATH"] = "google_certificate_path";
  return GoogleCertificateNavItemType;
}({});
export let BadgeNavItemType = /*#__PURE__*/function (BadgeNavItemType) {
  BadgeNavItemType["CERTIFICATIONS"] = "certifications";
  BadgeNavItemType["ORGANIZATION_BADGES"] = "organization_badges";
  BadgeNavItemType["ASSESSMENTS"] = "assessments";
  return BadgeNavItemType;
}({});

// Custom browse navigation item type for Grow with Google certifications
// This is used as a string type value in BrowseNavigationItemSelected events
export const GWG_CERTIFICATION_TYPE = 'grow_with_google';

// Constant ID for the Learn AI with Google L1 nav item
// Used as the ID string in BrowseNavigationItemSelected events for L1 items
export const LEARN_AI_WITH_GOOGLE_NAV_ID = '-1';

// Constant numeric ID for the Learn AI with Google L1 nav item
// Used as relatedEntityId (number) in BrowseNavigationItemSelected events for L2 items
export const LEARN_AI_WITH_GOOGLE_NAV_RELATED_ID = -1;
export class BadgeNavItemSelectEvent extends ClientEvent {
  constructor(itemType) {
    super('BadgeNavItemSelectEvent');
    this.itemType = void 0;
    this.itemType = itemType;
  }
}
export class SubscriptionOfferImpressionEvent extends ClientEvent {
  constructor(planId, uiRegion) {
    super('SubscriptionOfferImpressionEvent');
    this.planPriceId = void 0;
    this.uiRegion = void 0;
    this.planPriceId = planId;
    this.uiRegion = uiRegion;
  }
}

/**
 * Event fired when a clicks to learn more about a specific subscription plan
 */
export class SubscriptionLearnMoreEvent extends ClientEvent {
  constructor(planId, planType, uiRegion) {
    super('SubscriptionLearnMoreEvent');
    this.planPriceId = void 0;
    this.planType = void 0;
    this.uiRegion = void 0;
    this.planPriceId = planId;
    this.planType = planType;
    this.uiRegion = uiRegion;
  }
}
export const trackSubscriptionOfferImpressionEvent = uiRegion => {
  Tracker.publishEvent(new SubscriptionOfferImpressionEvent('-1', uiRegion));
};
export const trackSubscriptionLearnMoreEvent = uiRegion => {
  Tracker.publishEvent(new SubscriptionLearnMoreEvent('-1', SubscriptionPlanProductType.Consumersubscription, uiRegion));
};
export const trackUFBNoticeImpressionEvent = (udRequest, placement, ubHref) => {
  Tracker.publishEvent(new UFBNoticeImpressionEvent({
    locale: udRequest.locale,
    placement,
    url: ubHref
  }));
};
export const trackUFBNoticeClickEvent = (udRequest, placement, ubHref) => {
  Tracker.publishEvent(new UFBNoticeClickEvent({
    locale: udRequest.locale,
    placement,
    url: ubHref
  }));
};
export class LoginSelected extends ClientEvent {
  constructor() {
    super('LoginSelected');
  }
}
export class SignupSelected extends ClientEvent {
  constructor() {
    super('SignupSelected');
  }
}
export class SearchBarSelected extends ClientEvent {
  constructor() {
    super('SearchBarSelected');
  }
}

/**
 * Event fired when a user selects a topic in the AI Navigation section.
 *
 * @example
 * Tracker.publishEvent(new AITopicNavItemSelectEvent({
 *   id: 'Generative AI',
 *   type: 'topic',
 *   relatedEntityType: 'ai_navigation',
 * }));
 */
export class AITopicNavItemSelectEvent extends ClientEvent {
  constructor({
    id
  }) {
    super('AITopicNavItemSelectEvent');
    /** The topic name from the url or slug*/
    this.id = void 0;
    /** The type of the item, always 'topic' */
    this.type = void 0;
    /** The related entity type, always 'ai_navigation' */
    this.relatedEntityType = void 0;
    this.id = id;
    this.type = 'topic';
    this.relatedEntityType = 'ai_navigation';
  }
}
//# sourceMappingURL=events.js.map